export const wallpaperOptions = [
  { id: 'teal', label: 'Teal Grid' },
  { id: 'starfield', label: 'Starfield' },
  { id: 'sunset', label: 'Sunset' },
  { id: 'neon-horizon', label: 'Neon Horizon' },
  { id: 'midnight', label: 'Midnight Blue' },
  { id: 'checkerboard', label: 'Pixel Checkerboard' },
  { id: 'circuit', label: 'Circuit Board' },
  { id: 'clouds', label: 'Pixel Clouds' }
];
